import React from 'react'
import ModalFormUI from '../../../../widgets/form/ModalFormUI'
import InputDateUI from '../../../../widgets/form/InputDateUI'
import InputTextSF from '../../../../widgets/form/InputTextSF'

const CollectionModalUI = ({
  context, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
  // fields
  collectionDate, onCollectionDateChange, collectionDateError, setCollectionDateError,
  balanceAmount, onBalanceAmountChange, balanceAmountError, setBalanceAmountError,
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Invoice discount'
    buttonLabel='Save'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputDateUI context={context} name='date' label='Closing date'
      selectedDateISO={collectionDate} onChange={onCollectionDateChange}
      error={collectionDateError} setError={setCollectionDateError}
      required={true} help='Interest charged till previous date'
    /> 
    <InputTextSF type='text' name='balanceAmount' maxLength={12}
      label='Balance amount (if any)'
      value={balanceAmount} onChange={onBalanceAmountChange}
      error={balanceAmountError} setError={setBalanceAmountError}
    />

  </ModalFormUI>

export default CollectionModalUI
